"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
exports.useUpdate = () => {
    const [, setState] = react_1.useState(0);
    return () => setState(cnt => cnt + 1);
};
//# sourceMappingURL=useUpdate.js.map